<template>
  <v-app :class="templateConfig.theme">
    <div id="ObserverCont">
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'EmbeddedLayout',
  components: {},
  data() {
    return {
      mutationObserver: null,
      resizeObserver: null,
    };
  },
  methods: {},
  computed: {
    ...mapState(['templateConfig']),
  },
  async created() {},
  mounted() {
    let htmlElem = document.getElementById('html');
    htmlElem.classList.add('overflow-hidden');

    // send the app height to the parent iframe
    this.resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage(
        { appHeight: document.getElementById('ObserverCont').clientHeight },
        '*'
      );
    });
    this.resizeObserver.observe(document.getElementById('ObserverCont'));

    this.mutationObserver = new MutationObserver(() => {
      window.parent.postMessage(
        { appHeight: document.getElementById('ObserverCont').clientHeight },
        '*'
      );
    });
    this.mutationObserver.observe(document.getElementById('ObserverCont'), {
      childList: true, // listen to children being added or removed
      attributes: false, // listen to attributes changes
      subtree: true, // omit or set to false to observe only changes to the parent node
    });
  },
};
</script>
